import { apiRequest } from '../helpers'

export async function getCountries() {
  const response = await apiRequest(`${process.env.REACT_APP_API_URL}/countries`, 'GET')

  return response
}

export async function getCountryData(countryName: string) {
  const response = await apiRequest(
    `${process.env.REACT_APP_API_URL}/country/data/${countryName}`,
    'GET'
  )

  return response.country
}

export async function getBankCountries() {
  const response = await apiRequest(
    `${process.env.REACT_APP_API_URL}/stammdaten/bank/countries`,
    'GET'
  )
  return response.countries
}
